import { render, staticRenderFns } from "./bankLinkedTransactions.vue?vue&type=template&id=605bf7a4&"
import script from "./bankLinkedTransactions.vue?vue&type=script&lang=js&"
export * from "./bankLinkedTransactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports